import request from '@/utils/request';


export function List(data) {
  return request({
    url: 'api/goods/list',
    method: 'post',
    data: data
  })
}

export function Detail(data) {
  return request({
    url: 'api/goods/detail',
    method: 'post',
    data: data
  })
}








// WEBPACK FOOTER //
// ./src/api/goods.js